import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    CardImg,
    Card,
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import Caret from '../../public/site-assets/svg/caret.svg';
// import Curve_1 from "./images/svg/curve-style-1.svg"

export default function ImageWithText({
    global,
    pathPrefix,
    customClass = "",
    post,
    videoGalleryClass = "",
    content,
    buttonLink,
    buttonTitle,
    primaryBtn = false,
    flipColumn,
    fullWidthContainer = false,
    leftMdColumn = 5,
    rightMdColumn = 7,
    curve_1 = false
}) {

    return (
        <section className={`${styles.root} ${customClass} ${flipColumn ? "reverse-column" : null} ${fullWidthContainer ? "full-width" : null}`}>
            <Container>
                {content ?
                    <div className="text-center mb-5">
                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                            {content}
                        </SourceFlowText>
                    </div> : ""}
                <div>
                    {post.map((post, index) =>
                        <Row key={index} className="mb-4 m-0">
                            <Col md={leftMdColumn} className="p-0 position-relative">
                                {curve_1 ?
                                    <span className="position-absolute curve-1">
                                        <Curve_1 />
                                    </span> : null}
                                {post.video_link ?
                                    <Link href={`${post.video_link}`}>
                                        <a
                                            className="fancyBox d-block position-relative overflow-hidden h-100"
                                            data-fancybox={`${videoGalleryClass}`}
                                        >
                                            <SourceFlowImage
                                                src={post?.image ? post?.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                size="800x"
                                                alt={post?.title}
                                                className="card-img rounded-0 mb-4 h-100"
                                            />
                                            <span className="position-absolute play">
                                                <Caret />
                                            </span>
                                        </a>
                                    </Link> : <SourceFlowImage
                                        src={post?.image ? post?.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                        size="1000x"
                                        alt={post?.title}
                                        className="card-img rounded-0 mb-4 h-100"
                                    />}

                            </Col>
                            <Col md={rightMdColumn} className="pt-4 column-post">
                                <p className="fs-2"><strong>{post.title}</strong></p>
                                {post?.content ?
                                    <div className="mb-4" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                    : ""}
                                {post.button_link === 'https://www.impellam.com/' ?
                                    <Link href={`${post.button_link}`}>
                                        <a target = "_blank" className={`${primaryBtn ? "primaryBtn " : "secondaryBtn"} no-arrow mb-5`}>{post.button_title}</a>
                                    </Link> :   <Link href={`${post.button_link}`}>
                                        <a className={`${primaryBtn ? "primaryBtn " : "secondaryBtn"} no-arrow mb-5`}>{post.button_title}</a>
                                    </Link> }
                            </Col>
                        </Row>
                    )}
                </div>
                {buttonTitle ?
                    <div className="text-center mt-5">
                        <Link href={`${buttonLink}`}>
                            <a className="primaryBtn no-arrow m-0">
                                <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle`}>
                                    {buttonTitle}
                                </SourceFlowText>
                            </a>
                        </Link>
                    </div> : ""}
            </Container>
        </section >
    )
}